import {ProyectoState} from "./state"

export const mutations = {
    ADD_ASESORIA(state: ProyectoState, asesoria: any) {
        state.asesorias.push(asesoria);
    },
    ADD_CITA(state: ProyectoState, cita: any) {
        state.citas.push(cita);
    },
    SET_LOADING(state: ProyectoState, status: boolean) {
        state.loading = status;
    },
    SET_ERROR(state: ProyectoState, error: string | null) {
        state.error = error;
    },
};